import React from 'react';
import firewallOptions from './firewallOptions';
import $ from 'jquery';
import { FirewallService } from './../../services/firewall.service';
import ReactToolTip  from 'react-tooltip';
import { getMessage } from '../../constants/messagesMapper';
import { AuditLog } from './../../services/auditlog.service';
import isCidr from 'is-cidr';

class FirewallRules extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            enableedit: false,
            enablerules: false,
            firewalltype: '',
            enableditfirewall: '',
            getselectedoption: '',
            firewallOptions: firewallOptions,
            isFirewallEditShow: false,
            isDuplicateRules: false,
            sources: [
                {
                    ethertype: 'IPv4',
                    value: 'ALLIPv4',
                    remote_ip_prefix: '0.0.0.0/0'
                },
                {
                    ethertype: 'IPv6',
                    value: 'ALLIPv6',
                    remote_ip_prefix: '::/0'
                }
            ],
            rulesListApi: [],
            rulesList: [],
            isDisabled: false,
            selectedIndex: '',
            rowDeleteData: {},
            isRowElemUpdated: false,
            rowIndex:-1
        };
        this.setSelectedOption = this.setSelectedOption.bind(this)
    }

    enableEdit = (param) => {
        this.setState({
            enableedit: !this.state.enableedit,
            enableditfirewall: param

        })
    }
    editRow = (param) => {
        this.setState({
            enablerules: !this.state.enablerules,
            firewalltype: param
        })
    }
    setSelectedOption = (event, index) => {
        let val = event.target.value
        let rulesListsLoc = this.state.rulesList;

        let searchedElem = this.state.rulesList.find(elem => elem.type === val)
        if (searchedElem !== undefined && val!=='Custom') {
            this.setState({ isDuplicateRules: true,isRowElemUpdated:false });
            val = rulesListsLoc[index].type;
        }else {
            this.setState({ isDuplicateRules: false,isRowElemUpdated:true });
        }
        rulesListsLoc[index].type = val;
        let selectedElem = firewallOptions.find((item) => item.type === val);
        rulesListsLoc[index].protocol = selectedElem.protocol;
        rulesListsLoc[index].portRange = selectedElem.portRange;
        rulesListsLoc[index].minPort = selectedElem.minPort;
        rulesListsLoc[index].maxPort = selectedElem.maxPort;
        this.setState({
            rulesList: rulesListsLoc
        })
    }

    componentDidMount() {
        //this.setState({ rulesList: this.getInboundOrOutbound(this.props.rulesListApi) });
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.rulesListApi!==this.state.rulesListApi ){
            this.setState({ rulesList: this.getInboundOrOutbound(prevProps.rulesListApi),
                rulesListApi:prevProps.rulesListApi});
        }
    }


    getInboundOrOutbound(inpData) {
        let locData = [];
        if (inpData.length === 0) {
            return locData;
        }
        locData = this.setRowData(inpData);
        return locData;
    }
    setRowData(inpData) {
        let locData = [];
        for (let elem of inpData) {
            let newData ={};
            let sourceValue = getSourceValue(elem.remote_ip_prefix,elem.ethertype);
            if (elem.port_range_min === null && elem.protocol === null) {
                //elem.port_range_min=elem.port_range_max='';
                elem.protocol='any';
            }
            if(elem.protocol == 'ipv6-icmp'){
                elem.protocol = 'icmp'
            }
            newData = locData.find(e => e.minPort == elem.port_range_min && e.maxPort == elem.port_range_max && e.protocol == elem.protocol);
            if (newData === undefined) {
                newData = {};
                newData.staticSources = [];
                newData.protocol = elem.protocol;
                newData.maxPort = elem.port_range_max;
                newData.minPort = elem.port_range_min;
                let firewallOption = this.state.firewallOptions.find
                    (ob => ob.protocol == elem.protocol && ob.minPort == elem.port_range_min && ob.maxPort == elem.port_range_max);
                if (firewallOption===undefined){
                    newData.type = 'Custom';
                    if(elem.port_range_max!==elem.port_range_min){
                        newData.portRange = elem.port_range_min +':'+ elem.port_range_max;
                    }else{
                        newData.portRange = elem.port_range_min;
                    }
                } else {
                    newData.type = firewallOption.type;
                    newData.portRange = firewallOption.portRange;
                }
                newData.sources = [];
                newData.sources.push({
                    ethertype: elem.ethertype,
                    value: sourceValue,
                    id: elem.id,
                    direction: elem.direction,
                    remote_ip_prefix: elem.remote_ip_prefix
                });
                locData.push(newData);
            } else if (newData !== undefined) {
                newData.sources.push({
                    ethertype: elem.ethertype,
                    value: sourceValue,
                    direction: this.props.type,
                    id: elem.id,
                    remote_ip_prefix: elem.remote_ip_prefix
                });
            }
        }
        return locData;
    }

    onNewRulesSelectChange = (event) => {
        let val = event.target.value;
        let firewallOptionElem = firewallOptions.find(elem => elem.type === val);
        if (firewallOptionElem === undefined ) {
            this.setState({ isDuplicateRules: false });
            return;
        }
        let searchedElem = this.state.rulesList.find(elem => elem.type === val)
        if (searchedElem !== undefined && val!=='Custom') {
            this.setState({ isDuplicateRules: true });
            return;
        }
        searchedElem = {};
        searchedElem.staticSources = [];
        searchedElem.type = val;
        searchedElem.protocol = firewallOptionElem.protocol;
        searchedElem.portRange = firewallOptionElem.portRange;
        searchedElem.minPort = firewallOptionElem.minPort;
        searchedElem.maxPort = firewallOptionElem.maxPort;
        searchedElem.isRowUpdate = true;
        searchedElem.isNonSaved = true;
        searchedElem.sources = []
        this.state.sources.forEach(elem => {
            searchedElem.sources.push({
                ethertype: elem.ethertype,
                value: elem.value,
                direction: this.props.type,
                remote_ip_prefix:elem.remote_ip_prefix
            });
        })
        let rulesListLoc = this.state.rulesList;
        rulesListLoc.push(searchedElem);
        sessionStorage.removeItem('rowFocusData');
        this.setState({ rulesList: rulesListLoc, isDuplicateRules: false, isDisabled: true, selectedIndex: rulesListLoc.length - 1, isRowElemUpdated: true });
        event.currentTarget.value = 'New Rule'
    }

    onEditRuleFocus = (event, elem, index) => {
        if (this.state.isDisabled) {
            if (index === this.state.selectedIndex) {
                $(event.currentTarget).addClass('active');
            }
            return;
        }
        $(event.target.parentElement.parentElement.parentElement.parentElement.parentElement).addClass('edit_row');
        sessionStorage.setItem('rowFocusData', JSON.stringify(elem));
        elem.isRowUpdate = true;
        this.setState({ isDisabled: true, rulesList: this.state.rulesList, selectedIndex: index});
    }

    onRowCancelClick = (elem, index) => {
        let rulesListLoc = this.state.rulesList;
        if (elem.isNonSaved) {
            rulesListLoc.splice(index,1);
            this.setState({ isDisabled: false, rulesList: rulesListLoc });
            return;
        }
        rulesListLoc[index]=JSON.parse(sessionStorage.rowFocusData);
        rulesListLoc[index].isRowUpdate = undefined;
        this.setState({ isDisabled: false, rulesList: this.state.rulesList });
    }

    onRowSaveClick = (event, elem, index) => {
        elem.sourcesDropDown = ''
        let i18n = this.props.i18n
        if (this.state.isRowElemUpdated) {
            this.props.bgShadowHandler(true);
            let requestBody = [];
            if(sessionStorage.rowFocusData){
                let element = JSON.parse(sessionStorage.rowFocusData);
                element.sources.forEach(item => {
                    if (item.id !== undefined && item.id !== '') {
                        requestBody.push(item.id);
                    }
                });
                if (requestBody.length > 0) {
                    FirewallService.deleteFirewallRulesByRulesId(this.props.regionUrl,
                        JSON.stringify(requestBody)).then(resp => {
                            if (resp) {
                                this.saveNextState(elem,index);
                                return;
                            }
                            this.props.bgShadowHandler(false);
                            this.props.handler(i18n.t('fw_rules_save_failure'), 'error');
                            return;
                        });
                } 
            } else {
                this.saveNextState(elem,index);
            }
        }
        elem.isRowUpdate = undefined;
        this.setState({ isDisabled: false, rulesList: this.state.rulesList, isRowElemUpdated: false })
    }

    saveNextState(elem,index) {
        let requestBodyArr = this.constructRequestBody(elem);

        if (requestBodyArr.length === 0) {
            let newRulesList = this.state.rulesList;
            newRulesList.splice(index,1);
            this.setState({ rulesList: newRulesList });
            this.props.updateCountHandler();
            this.props.bgShadowHandler(false);
            this.props.handler('Removed the element since sources are not provided', 'success');
            return;
        }
        let i18n = this.props.i18n
        FirewallService.addFirewallRules(this.props.regionUrl, JSON.stringify(requestBodyArr)).then(resp => {
            this.props.bgShadowHandler(false);
            if (resp) {
                let errorMessg = undefined
                resp.forEach(respItem => {
                    let data = respItem.security_group_rule;
                    if(data === undefined && respItem.NeutronError) {
                        errorMessg= respItem.NeutronError.message
                        return
                    }
                    try {
                        let filteredData = elem.sources.find(source => source.ethertype === data.ethertype && data.remote_ip_prefix.includes(source.remote_ip_prefix))
                        filteredData.id = data.id
                    }
                    catch (err) {
                        console.log("sg"+data)
                    }
                    elem.isNonSaved = false;
                });
                if(errorMessg !== undefined) {
                    errorMessg = errorMessg.replace('None,','')
                    let newMessage = getMessage(errorMessg)
                    this.props.handler(newMessage, 'error')
                    elem.isRowUpdate = true;
                    this.setState({ isDisabled: true, rulesList: this.state.rulesList,isRowElemUpdated:true })
                    return
                }
                const editFirewall = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Firewall "+this.props.firewallName+" rule has been updated",
                    "operation": "Firewall rule updated"
                } 
                AuditLog.storeAuditLogs(editFirewall, "instance").then((resp) => {
                    if (resp === false);
                })
                this.props.handler(i18n.t('fw_rules_save_success'), 'success');
                this.setState({ rulesList: this.state.rulesList });
                this.props.updateCountHandler();
            } else {
                this.props.handler(i18n.t('fw_rules_save_failure'), 'error');
            }
        });
    }

    constructRequestBody(elem) {
        let requestBodyArr = [];
        elem.sources.forEach(item => {
            let requestBodyElem = {};
            requestBodyElem.direction = this.props.type;
            requestBodyElem.ethertype = item.ethertype;
            if(elem.portRange!==undefined && elem.portRange !=='') {
                requestBodyElem.port_range_max = elem.maxPort;
                requestBodyElem.port_range_min = elem.minPort;
            }
            requestBodyElem.protocol = elem.protocol;
            if(elem.protocol==='any'){
                requestBodyElem.port_range_max = elem.maxPort = null;
                requestBodyElem.port_range_min = elem.minPort = null;
                requestBodyElem.protocol = null;
                //elem.portRange ="";
            }
            requestBodyElem.remote_ip_prefix = item.remote_ip_prefix;
            requestBodyElem.security_group_id = this.props.id
            requestBodyArr.push(requestBodyElem);
        });
        return requestBodyArr;
    }


    onRowDeleteClick = (event) => {
        this.deletePopupClose()
        this.props.bgShadowHandler(true);
        let requestBody = [];
        let i18n = this.props.i18n
        this.state.rowDeleteData.sources.forEach(item => {
            if (item.id !== undefined && item.id !== '') {
                requestBody.push(item.id);
            }
        });

        FirewallService.deleteFirewallRulesByRulesId(this.props.regionUrl,
            JSON.stringify(requestBody)).then(resp => {
                this.props.bgShadowHandler(false);
                if (resp) {
                    let filtData = this.state.rulesList
                    filtData.splice(this.state.rowIndex,1)
                    this.setState({rulesList:filtData,rowDeleteData:{},isDuplicateRules: false});
                    const editFirewall = {
                        "userId": localStorage.getItem("userId"),
                        "name": "Firewall "+this.props.firewallName+" rule has been deleted",
                        "operation": "Firewall rule deleted"
                    } 
                    AuditLog.storeAuditLogs(editFirewall, "instance").then((resp) => {
                        if (resp === false);
                    })
                    this.props.handler(i18n.t('fw_rules_delete_success'), 'success');
                    this.props.updateCountHandler();
                    return;
                }
                this.props.handler(i18n.t('fw_rules_delete_failure'), 'error');
                return;
            });
    }

    onSourceDeleteClick(ruleListindex, sourcesIndex) {
        let rulesListLoc = this.state.rulesList;
        if(!rulesListLoc[ruleListindex].isRowUpdate){
            return
        }
        rulesListLoc[ruleListindex].sources.splice(sourcesIndex, 1);
        this.setState({rulesList: rulesListLoc,isRowElemUpdated:true});
    }

    protocolChange = (event,index) => {
        let rulesListLoc = [...this.state.rulesList];
        rulesListLoc[index].protocol= event.target.value;
        this.setState({rulesList:rulesListLoc,isRowElemUpdated:true});
    }

    portRangeChange = (event,index) => {
        let val = event.target.value;
        let rulesListLoc = [...this.state.rulesList];
        rulesListLoc[index].portRange = val;
        if(val.includes(':')){
            let newValArray = val.split(':');
            rulesListLoc[index].minPort = newValArray[0];
            rulesListLoc[index].maxPort = newValArray[1];
        }else if(val===''){
            rulesListLoc[index].minPort = 1;
            rulesListLoc[index].maxPort = 65535;
        }else {
            rulesListLoc[index].minPort = val;
            rulesListLoc[index].maxPort = val;
        }
        this.setState({rulesList:rulesListLoc,isRowElemUpdated:true});
    }

    sourcesDropDownChange = (event,elem) => {
        let rulesListLoc = this.state.rulesList;
        let dropDownArr = [{key:'IPv4',value:'ALLIPv4'},{key:'IPv6',value:'ALLIPv6'}];
        elem.sources.forEach(item => {
            dropDownArr = dropDownArr.filter(key=>key.value!==item.value);
        });
        if(validateIpAddressRange(event.target.value)) {
            dropDownArr.push({key:event.target.value,value:'Add '+event.target.value+' as an address'});
        }
        if(dropDownArr.length>0){
            elem.staticSources = dropDownArr;
            $(event.target.parentElement.parentElement.parentElement).find('.autoComplete_dropdown').addClass('active');
        }
        elem.sourcesDropDown = event.target.value;
        this.setState({rulesList:rulesListLoc});
    }

    onDropDownSelect = (event,stSource,elem) => {
        elem.staticSources = elem.staticSources.filter(element=>element!==stSource);
        $(event.target.parentElement.parentElement).removeClass('active');
        if(stSource.value.includes('Add')){
            elem.sources.push({
                ethertype: getEtherType(stSource.key),
                value: stSource.key,
                remote_ip_prefix: stSource.key,
                direction: this.props.type
            });
        }else{
            elem.sources.push({
                ethertype: stSource.key,
                value: stSource.value,
                remote_ip_prefix: getRemotePrefix(stSource.key),
                direction: this.props.type
            });
        }
        elem.sourcesDropDown='';
        this.setState({rulesListApi:this.state.rulesListApi,isRowElemUpdated:true});
    }

    deletePopup(elem,index) {
        this.setState({rowDeleteData:elem,rowIndex:index})
        $('#'+this.props.type).addClass('active');
    }

    deletePopupClose(){
        $('#'+this.props.type).removeClass('active');
    }

    render() {
        return (
            <React.Fragment>
                <div className="rules_table clearfix">
                    <div className="tabular_data_wrap">
                        <div className="table_header">
                            <ul>
                                <li className="th">
                                    <div className="col col1">Type</div>
                                    <div className="col col2">Protocol</div>
                                    <div className="col col3">Port Range</div>
                                    <div className="col col4">Sources</div>
                                    <div className="col col5">Actions</div>
                                </li>
                            </ul> 
                        </div>
                        <div className="table_data">
                            <ul>
                                {this.state.rulesList.map((elem, i) =>
                                    <li className="tr edit_row" key={i} style={{ background: elem.isRowUpdate === undefined ? 'none' : '#f3f9fd' }}>
                                        <div className="col col1">
                                            <span style={{ display: elem.isRowUpdate === undefined ? 'inline-block' : 'none' }}>{elem.type}</span>
                                            <div className="custom_select_box" style={{ display: elem.isRowUpdate === undefined ? 'none' : 'inline-block' }}>
                                                <select name="selectedType" value={elem.type} onChange={(e) => this.setSelectedOption(e, i)}>
                                                    {this.state.firewallOptions.map((option, k) =>
                                                        <option key={k} value={option.type} >{option.type}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col col2 edit_active">
                                            <span style={{ display: elem.type === 'Custom' && elem.isRowUpdate? 'none' : 'inline-block' }} >{elem.protocol}</span>
                                            <input type="text" className="txtBox editable_txtBox protocol" name="protocol" style={{ display: elem.isRowUpdate !== undefined && elem.type=='Custom' ? 'inline-block' : 'none' }} 
                                            value={elem.protocol} autoComplete="off" onChange={(e)=>this.protocolChange(e,i)}/>
                                        </div>
                                        <div className="col col3 edit_active">
                                            <div className="txt_box_wrap">
                                            <span style={{ display: elem.type === 'Custom' && elem.isRowUpdate ? 'none' : 'inline-block' }} >{elem.portRange}</span>
                                            <input type="text" autoComplete="off" className="txtBox editable_txtBox protocol" name="portRange" style={{ display: elem.isRowUpdate !== undefined && elem.type == 'Custom' ? 'inline-block' : 'none' }}
                                                value={elem.portRange} onChange={(e) => this.portRangeChange(e, i)} />
                                            <span className="question_icon tooltips" style={{ display: elem.isRowUpdate !== undefined && elem.type == 'Custom' ? 'inline-block' : 'none' }} data-tip data-for={"qIcon"+i}>
                                                <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                    <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                    <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                </svg>
                                            </span><ReactToolTip id={"qIcon"+i} place="top" effect="solid">Specify a port (80) or range ( 4000:5000) or leave blank for all ports</ReactToolTip>
                                            </div>
                                        </div>
                                        <div className="col col4">
                                            <div className={elem.isRowUpdate === undefined ? "added_source clearfix" : "added_source clearfix active"} onFocus={(e) => this.onEditRuleFocus(e, elem, i)}>
                                                <ul className="tags_container">
                                                    {elem.sources.map((source, j) =>
                                                        <li key={j}>
                                                            <div className="source_tag" >{source.value}<span className="close_icon" title="" style={{display:elem.isRowUpdate === undefined?'none':''}} onClick={() => this.onSourceDeleteClick(i,j)}></span></div>
                                                        </li>
                                                    )}
                                                    <span className="inp_box">
                                                        <input type="text" name="sourcesDropDown" className="input_search" style={{ width: '120px' }} value={elem.sourcesDropDown} onChange={(e)=>this.sourcesDropDownChange(e,elem)}></input>
                                                    </span>
                                                </ul>
                                                <div className="dropdown_component autoComplete_dropdown">
                                                    <ul>{elem.staticSources.map((stSource,m) =>
                                                             <li key={m} onClick={(e)=>this.onDropDownSelect(e,stSource,elem)}>{stSource.value}</li>
                                                        )}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col col5"><span className="icon delete" style={{ display: this.state.isDisabled ? 'none' : 'inline-block' }} onClick={() => this.deletePopup(elem,i)}> <svg data-tip data-for= "delete" x="0px" y="0px" viewBox="0 0 18 18" enableBackground="new 0 0 18 18" xmlSpace="preserve">
                                            <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M16.1,3.3v12c0,1.1-0.9,2-2,2h-10c-1.1,0-2-0.9-2-2v-12h-1v-2h3h1  v-1h8v1h1h3v2H16.1z M14.1,3.3h-10v12h10V3.3z M8.1,13.3h-2v-8h2V13.3z M12.1,13.3h-2v-8h2V13.3z"></path>
                                        </svg><ReactToolTip id = "delete" place="top" effect="solid">Delete</ReactToolTip></span>
                                            <div className="cta_wrap" style={{ display: elem.isRowUpdate !== undefined ? 'flex' : 'none' }}>
                                                <input type="button" value="Save" className="common_cta_btn blue" onClick={(e) => this.onRowSaveClick(e, elem,i)} />
                                                <span className="close_icon" onClick={() => this.onRowCancelClick(elem, i)}></span>
                                                {/* <input type="button" value="Cancel" className="common_cta_btn cancel" onClick={() => this.onRowCancelClick(elem, i)} /> */}
                                            </div>
                                        </div>
                                    </li>

                                )
                                }
                                <li className="tr new_rule">
                                    <div className="col col1">
                                        <div className="custom_select_box">
                                            <select onChange={this.onNewRulesSelectChange} disabled={this.state.isDisabled}>
                                                <option>New Rule</option>
                                                {this.state.firewallOptions.map((option, i) =>
                                                    <option key={i} value={option.type} >{option.type}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </li>
                                <li className="tr error_row" style={{ display: this.state.isDuplicateRules ? '' : 'none' }}>
                                    <div className="col col1">
                                        <div className="err_box">
                                            <div className="err_content">Rules list contains duplicate rules</div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="main_popup delete_firewall_popup" id={this.props.type}>
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" onClick={()=>this.deletePopupClose()} title="" ></span>
                                <div className="popup_header">
                                    <div className="sub_title"> Delete</div>
                                </div>
                                <div className="popup_body">
                                    <p>Are you sure you want to delete the <b>{this.state.rowDeleteData.type} </b> rule</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <button className="btn btn_confirm" onClick={this.onRowDeleteClick}>Delete</button>
                                        <button className="btn btn_cancel" onClick={()=>this.deletePopupClose()}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
function validateIpAddressRange(ipAddress) {
    if(ipAddress && ipAddress.includes('/')) {
        var val = isCidr(ipAddress)
        if(val===4 || val===6) return true
    }
    return validateIpAddress(ipAddress);
}
function validateIpAddress(ipAddress) {
    var expression =  /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
    return expression.test(ipAddress);
}
function getEtherType(value) {
    if(value.includes(':')) {
        return 'IPv6';
    }
    return 'IPv4';
    
}
function getRemotePrefix(type){
    if(type==='IPv4'){
        return '0.0.0.0/0';
    }
    return '::/0';
}
function getSourceValue(ipPrefix,ethertype) {
    if (ipPrefix === '0.0.0.0/0') {
        return 'ALLIPv4';
    } else if (ipPrefix === '::/0') {
        return 'ALLIPv6';
    } else if (ipPrefix===null){
        return 'ALL'+ethertype;
    }else{
        return ipPrefix;
    }
}

export default FirewallRules;